import { useQuery } from '@tanstack/react-query';
import apiClient from '../api-client';

export type MySquaresPick = {
  squares_contest_id: string;
  pickem_id?: string;
  question_id?: string;
  contest_name_en?: string;
  contest_name_fr?: string;
  status: string;
  start_time_utc?: string;
  row_team_display_name?: string;
  col_team_display_name?: string;
  total_prize_amount: number;
  total_entries_to_date: number;
  sport: string;
  user_selected_square?: number;
  user_selected_row_index?: number;
  user_selected_col_index?: number;
  row_digits?: number[];
  col_digits?: number[];
  /** User's total winnings for this contest (sum across all periods) */
  total_winnings?: number;
  // Reserve a Seat (DKPLAT-529) — shared infra with Pick'em (DKPLAT-528)
  has_reservation?: boolean;
  has_selections?: boolean;
  has_entered?: boolean;
  questions_posted_at?: string | null;
  /**
   * Live "squares are now open for picks" signal (mirrors Pick'em's hasQuestions).
   * Distinct from questions_posted_at (a display-only timestamp that stays set
   * forever) — this is the runtime boolean that flips the reserved My Games card
   * from "Entry Reserved" to the enabled "No Picks Submitted - Make Selections
   * Now!" state (DKPLAT-529).
   */
  has_questions?: boolean;
  [key: string]: any;
};

type GetMyPicksResponse = {
  squares_contests: MySquaresPick[];
};

export const getMyPicks = () => apiClient.get<GetMyPicksResponse>('/api/squares/user/my-picks');

export const useGetMyPicksQuery = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: ['squares', 'my-picks'],
    queryFn: getMyPicks,
    select: data => data.squares_contests || [],
    enabled: options?.enabled !== false,
    refetchOnMount: 'always',
  });
};
